export const queryKeys = {
	all: ["ccflare"] as const,
	accounts: () => [...queryKeys.all, "accounts"] as const,
	stats: () => [...queryKeys.all, "stats"] as const,
	analytics: (
		timeRange?: string,
		filters?: unknown,
		viewMode?: string,
		modelBreakdown?: boolean,
	) =>
		[
			...queryKeys.all,
			"analytics",
			{ timeRange, filters, viewMode, modelBreakdown },
		] as const,
	requests: (limit?: number) =>
		[...queryKeys.all, "requests", { limit }] as const,
	requestConversation: (requestId: string) =>
		[...queryKeys.all, "request-conversation", { requestId }] as const,
	requestPayload: (requestId: string) =>
		[...queryKeys.all, "request-payload", { requestId }] as const,
	logs: () => [...queryKeys.all, "logs"] as const,
	logHistory: () => [...queryKeys.all, "logs", "history"] as const,
	gatewayStatus: () => [...queryKeys.all, "gateway-status"] as const,
	me: () => [...queryKeys.all, "me"] as const,
	apiKeys: () => [...queryKeys.all, "api-keys"] as const,
	groups: () => [...queryKeys.all, "groups"] as const,
} as const;
